import { c as _c } from "react/compiler-runtime";
import type { InferGetStaticPropsType, NextPage } from "next";
import { HomeLandingFaq } from "#/features/homePage/ui/landing/HomeLandingFaq";
import { HomeLandingHero } from "#/features/homePage/ui/landing/HomeLandingHero";
import { HomeLandingSections } from "#/features/homePage/ui/landing/HomeLandingSections";
import { getI18nPropsWithCanonical } from "#/i18n/getI18nProps";
import { useI18nContext } from "#/shared/hooks";
import { SiteSeoHead } from "#/shared/ui/seo/SiteSeoHead";
import { MainLayout } from "#/shared/ui/templates/MainLayout";
export const getStaticProps = getI18nPropsWithCanonical("/");
type DashboardProps = InferGetStaticPropsType<typeof getStaticProps>;
const DashboardPage: NextPage<DashboardProps> = t0 => {
  const $ = _c(11);
  const {
    canonicalUrl
  } = t0;
  const {
    LL
  } = useI18nContext();
  let t1;
  if ($[0] !== canonicalUrl) {
    t1 = <SiteSeoHead title={"dStruct \u2014 visualize LeetCode solutions"} canonicalUrl={canonicalUrl} />;
    $[0] = canonicalUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] !== LL) {
    t2 = <HomeLandingHero LL={LL} />;
    t3 = <HomeLandingSections LL={LL} />;
    t4 = <HomeLandingFaq LL={LL} />;
    $[2] = LL;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <MainLayout headerPosition="fixed">{t1}{t2}{t3}{t4}</MainLayout>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default DashboardPage;